import { createAction, props } from '@ngrx/store';
import { ISetting } from '../../setting/interface/setting.interface';

export const setSettings = createAction(
    '[Settings] Set Settings',
    props<{ settings: ISetting | null }>(),
);
